import { useTranslation } from "react-i18next";
import { FirestoreProductSubject } from "reedy-data/api";
import { CopyableListItem } from "~/components/list/copyable-list-item";

interface ThemaCodeItemProps {
  subject: FirestoreProductSubject;
  index: number;
  onCopy: (code: string) => void;
}

export const ThemaCodeItem = ({
  subject,
  index,
  onCopy,
}: ThemaCodeItemProps) => {
  const { t } = useTranslation(["general"]);
  const code = subject.subjectCode || "";
  const description = subject.subjectHeadingText || "";

  return (
    <CopyableListItem
      text={code.toUpperCase()}
      subtext={description}
      index={index}
      testId={`thema-code-${code}`}
      onCopy={() => onCopy(code)}
      copyLabel={t("general:buttons.copy")}
      analyticsId={`copy_thema_code_${code}`}
      className="items-start"
    />
  );
};
